<template>
  <div class="activity-game">
    <span
      v-if="descriptionPage"
      class="comet-screenreader-only"
      :aria-label="descriptionPage"
      role="text"
      tabindex="0"
      >{{ descriptionPage }}</span
    >
    <span
      v-if="accessibilityInstructions"
      class="comet-screenreader-only"
      :aria-label="accessibilityInstructions"
      role="text"
      tabindex="0"
      >{{ accessibilityInstructions }}</span
    >
    <slot></slot>
  </div>
</template>
<script>
import { BaseMixins } from '@discoveryeducation/core';

export default {
  name: 'ActivityGame',
  mixins: [BaseMixins.zoomManagerMixin],
  props: {
    descriptionPage: {
      type: String,
    },
    accessibilityInstructions: {
      type: String,
    },
  },
};
</script>

<style lang="stylus" scoped>

.activity-game
  min-height 100%
  height 100%
  position relative
</style>
